import { observer } from 'mobx-react';
import { useStore } from '../../../core/utils/hook';
import classNames from 'classnames';
import {
    DATE_YMD_ISO,
    FILTER_STATUS_STUDENT_OF_TRAINING_COURSE,
    FILTER_STATUS_STUDENT_OF_TRAINING_COURSE_MAPPER,
    FILTER_STATUS_SUBMIT_OF_TRAINING_COURSE,
    FILTER_STATUS_SUBMIT_QUESTION_OF_TRAINING_COURSE_MAPPER,
    FILTER_STATUS_SUBMIT_REPORT_OF_TRAINING_COURSE_MAPPER
} from '../../../core/configs/constants';
import moment from 'moment';
import { CalendarCustom } from '../../../components';
import { useState } from 'react';
import { flowResult } from 'mobx';

const FilterStudentOfTrainingCourseModal = observer((props) => {
    // props
    const {
        id,
        search
    } = props;

    // store
    const { modalStore: { hide }, courseStore: { filterStudentOfTrainingCourse, getTrainingCourseDetailForGA } } = useStore();

    // state
    const [status, setStatus] = useState(filterStudentOfTrainingCourse.status);
    const [fromCompletionDate, setFromCompletionDate] = useState(filterStudentOfTrainingCourse.fromCompletionDate);
    const [toCompletionDate, setToCompletionDate] = useState(filterStudentOfTrainingCourse.toCompletionDate);
    const [submitReporStatus, setSubmitReporStatus] = useState(filterStudentOfTrainingCourse.submitReporStatus);
    const [submitQuestionStatus, setSubmitQuestionStatus] = useState(filterStudentOfTrainingCourse.submitQuestionStatus);

    // function
    const onsubmit = async () => {
        const searchParams = {
            ...filterStudentOfTrainingCourse,
            search,
            status,
            fromCompletionDate,
            toCompletionDate,
            submitReporStatus,
            submitQuestionStatus
        };
        const res = await flowResult(getTrainingCourseDetailForGA(id, searchParams));
        if (res) {
            hide();
        }
    }

    return (
        <form className='filter-student-training-course-modal'>
            <div className='filter-container pd-lr-20'>
                <div className='filter-item'>
                    <div className='filter-item-header'>受講状況</div>
                    <div className='filter-item-options'>
                        {
                            Object.values(FILTER_STATUS_STUDENT_OF_TRAINING_COURSE).map((item, index) => {
                                const isActive = status === item;
                                return (
                                    <FilterOptionItem
                                        key={index}
                                        onClick={() => setStatus(prev => {
                                            if ((item === FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.NOT_ATTEND ||
                                                item === FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.ATTENDING) && 
                                                prev === FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.COMPLETED) {
                                                setSubmitReporStatus(null);
                                                setSubmitQuestionStatus(null);
                                            }
                                            return !prev || prev !== item ? item : null;
                                        })}
                                        isActive={isActive}
                                        text={FILTER_STATUS_STUDENT_OF_TRAINING_COURSE_MAPPER[item]?.LABEL} />
                                );
                            })
                        }
                    </div>
                </div>
                <div className='filter-item'>
                    <div className='filter-item-header'>受講完了日</div>
                    <div className='filter-item-options'>
                        <CalendarCustom
                            date={fromCompletionDate || null}
                            displayMode={'date'}
                            onChange={date => {
                                setFromCompletionDate(date ? moment(date).format(DATE_YMD_ISO) : null)
                            }}
                        />
                        <div>~</div>
                        <CalendarCustom
                            date={toCompletionDate || null}
                            displayMode={'date'}
                            onChange={date => {
                                setToCompletionDate(date ? moment(date).format(DATE_YMD_ISO) : null)
                            }}
                        />
                    </div>
                </div>
                <div className='filter-item'>
                    <div className='filter-item-header'>提出物</div>
                    <div className='filter-item-options'>
                        {
                            Object.values(FILTER_STATUS_SUBMIT_OF_TRAINING_COURSE).map((item, index) => {
                                const isActive = submitReporStatus === item;
                                return (
                                    <FilterOptionItem
                                        key={index}
                                        onClick={() => setSubmitReporStatus(prev => {
                                            if (!prev || prev !== item) {
                                                setStatus(FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.COMPLETED);
                                            } else {
                                                if (status === FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.COMPLETED && !submitQuestionStatus) {
                                                    setStatus(null);
                                                }
                                            }
                                            return !prev || prev !== item ? item : null;
                                        })}
                                        isActive={isActive}
                                        disable={status === FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.ATTENDING ||
                                            status === FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.NOT_ATTEND}
                                        text={FILTER_STATUS_SUBMIT_REPORT_OF_TRAINING_COURSE_MAPPER[item]?.LABEL} />
                                );
                            })
                        }
                    </div>
                </div>
                <div className='filter-item'>
                    <div className='filter-item-header'>質問</div>
                    <div className='filter-item-options'>
                        {
                            Object.values(FILTER_STATUS_SUBMIT_OF_TRAINING_COURSE).map((item, index) => {
                                const isActive = submitQuestionStatus === item;
                                return (
                                    <FilterOptionItem
                                        key={index}
                                        onClick={() => setSubmitQuestionStatus(prev => {
                                            if (!prev || prev !== item) {
                                                setStatus(FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.COMPLETED);
                                            } else {
                                                if (status === FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.COMPLETED && !submitReporStatus) {
                                                    setStatus(null);
                                                }
                                            }
                                            return !prev || prev !== item ? item : null;
                                        })}
                                        isActive={isActive}
                                        disable={status === FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.ATTENDING ||
                                            status === FILTER_STATUS_STUDENT_OF_TRAINING_COURSE.NOT_ATTEND}
                                        text={FILTER_STATUS_SUBMIT_QUESTION_OF_TRAINING_COURSE_MAPPER[item]?.LABEL} />
                                );
                            })
                        }
                    </div>
                </div>
            </div>
            <div className='d-flex justify-content-center align-items-center flex-gap-30 pd-tb-10'
                style={{ borderTop: '1px solid #d3d3d3' }}>
                <button type='button' className='btn btn-default-1 cancel-button min-width-120' onClick={() => hide()}>キャンセル</button>
                <button 
                    type='button'
                    onClick={onsubmit}
                    className='btn btn-default min-width-120' style={{ backgroundColor: '#4EA953', color: '#FFF'}}>
                    適用 
                </button>
            </div>
        </form>
    )
});

const FilterOptionItem = ({ isActive, text, onClick, disable = false }) => {
    console.log(disable);
    
    return (
        <div 
            className={classNames('filter-option-item', isActive && 'active', disable ? 'cursor-pointer-none opacity-50' : 'cursor-pointer')}
            onClick={disable ? () => {} : onClick}
        >
            {text}
        </div>
    );
}


export default FilterStudentOfTrainingCourseModal;